import { render, staticRenderFns } from "./LocationGroups.vue?vue&type=template&id=d2d2c79a"
import script from "./LocationGroups.vue?vue&type=script&lang=js"
export * from "./LocationGroups.vue?vue&type=script&lang=js"
import style0 from "./LocationGroups.vue?vue&type=style&index=0&id=d2d2c79a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports